import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

function Services() {
  const [serviceName, setserviceName] = useState("");
  const [status, setStatus] = useState("active");
  const [services, setservices] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchservices = async () => {
    try {
      const res = await authFetch("/api/v1/product_services/list");
      if (!res) return;
      const data = await res.json();
      if (Array.isArray(data)) setservices(data);
      else setservices([]);
    } catch (err) {
      showToast("Failed to fetch services", "error");
    }
  };

  useEffect(() => {
    fetchservices();
  }, []);

  const showToast = (message, type = "success") => {
    if (window.toastr) {
      toastr.options = {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: "3000",
      };
      toastr[type](message);
    }
  };

  const handleCreateOrUpdateservice = async () => {
    if (!serviceName.trim()) {
      showToast("service name is required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/product_services/update"
      : "/api/v1/product_services/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        body: JSON.stringify({
          id: editingId,
          name: serviceName,
          status,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "service updated" : "service created", editingId ? "info" : "success");

      setserviceName("");
      setEditingId(null);
      fetchservices();

      // Close modal
      document.querySelector("#exampleModal .btn-close").click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (service) => {
    setserviceName(service.name);
    setStatus(service.status || "active");
    setEditingId(service.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this service?")) return;

    try {
      const res = await authFetch(`/api/v1/product_services/delete/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("service deleted", "error");
      fetchservices();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  useEffect(() => {
    if (services.length === 0) return;
  
    const $ = window.$;
    const interval = setInterval(() => {
      const table = $("#example2");
      if (!table.length || !$.fn.DataTable) return;
  
      try {
        if ($.fn.DataTable.isDataTable(table)) {
          table.DataTable().destroy();
        }
  
        const dt = table.DataTable({
          lengthChange: false,
          pageLength: 10,
          order: [[0, "desc"]], 
        });
  
        dt.buttons().container().appendTo("#example2_wrapper .col-md-6:eq(0)");
        clearInterval(interval);
      } catch (err) {
        console.error("DataTable init error:", err);
      }
    }, 100);
  
    return () => clearInterval(interval);
  }, [services]);

  return (
    <>
      <div className="page-wrapper">
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">Service Manager</h4>
                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => {
                      setserviceName("");
                      setEditingId(null);
                    }}
                  >
                    Add
                  </button>
                </div>

                {/* Modal */}
                <div
                  className="modal fade"
                  id="exampleModal"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {editingId ? "Edit service" : "Add service"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <input
                          className="form-control"
                          placeholder="Enter service Name"
                          value={serviceName}
                          onChange={(e) => setserviceName(e.target.value)}
                        />
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateOrUpdateservice}
                          disabled={loading}
                        >
                          {loading
                            ? "Saving..."
                            : editingId
                            ? "Update"
                            : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <hr />
                <div className="table-responsive">
                  <table id="example2" className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>service Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      {services.length === 0 && (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No services found
                          </td>
                        </tr>
                      )}
                      {services.map((service,i) => (
                        <tr key={service.id}>
                          <td>{i + 1}</td> 
                          <td>{service.name}</td>
                          <td>{service.status}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              onClick={() => handleEdit(service)}
                            >
                             <span className="bx bx-edit"></span>
                            </button>
                            <button
                              className="btn btn-sm btn-danger d-none"
                              onClick={() => handleDelete(service.id)}
                            >
                             <span className="bx bx-trash"></span>
                            </button>
                          </td>
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
}

export default Services;
